<template>
  <div class="question-tab">
    <p>{{ heading }}</p>

    <div class="button-div">
      <button
        v-for="item in data"
        :key="item.id"
        @click="handleClick(item)"
        :class="
          selectedBrands.length!=0 && selectedBrands.includes(item.id)
            ? 'green-btn'
            : 'default-btn'
        "
      >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "brandsMultipleButton",
  data() {
    return {
      clicked: false,
      selectedBrands: [],
      selectedIntersets: [],
    };
  },
  props: {
    heading: String,
    type: String,
    data: Array,
    getData: Function,
    selectedValues: Array,
  },
  mounted() {
    console.log(this.data);
  },
  created() {
    this.selectedBrands = this.$store.getters["crmFilters/GET_BRANDS_DATA"]
      ? this.$store.getters["crmFilters/GET_BRANDS_DATA"]
      : [];
  },
  methods: {
    handleClick(item) {
      // this.clicked = !this.clicked;
      console.log("item", item);
      if (!this.selectedBrands.includes(item.id))
        this.selectedBrands.push(item.id);
      else {
        const index = this.selectedBrands.indexOf(item.id);
        if (index > -1) {
          // only splice this.selectedBrands when item is found

          this.selectedBrands.splice(index, 1); // 2nd parameter means remove one item only
        }
      }

      console.log("states", this.selectedBrands);
      this.$store.dispatch(
        "crmFilters/setBrandsData",
        this.selectedBrands
      );
    },
    getValues() {
      return this.selectedBrands;
    },
  },
};
</script>
<style lang="scss" scoped>
.question-tab {
  display: flex;
  flex-direction: column;
  margin-left: 28px;
  // margin-top:28px;
  //row-gap: 24px;
  overflow-y: scroll;
  p {
    margin: 0;
  }
}
.button-div {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  //height: 100px;
}
.default-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #4b4b4b;
  padding: 8px 12px;
  border-radius: 4px;
}
.green-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #189d3b;
  background: #f3faf5;
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
